// import { Icon } from '../icon'
import type { ToggleProps } from '../input'

export const CurrencyCreditToggle = (_props: ToggleProps) => {
  return null

  // todo: temporarily remove currency credit toggle as part of QFMP-3979
  // const creditsIcon = (
  //   <Icon
  //     name="CircleStackIcon"
  //     size="sm"
  //     fill="solid"
  //     color="primary-inverse"
  //   />
  // )
  //
  // const moneyIcon = (
  //   <Icon
  //     name="CurrencyDollarIcon"
  //     size="sm"
  //     fill="solid"
  //     color="primary-inverse"
  //   />
  // )
  //
  // return (
  //   <Toggle
  //     {...props}
  //     alwaysOn
  //     checkedIcon={creditsIcon}
  //     unCheckedIcon={moneyIcon}
  //   />
  // )
}
